<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading">
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="!requestloading && requestfail"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />

              <h1 class="subtitle is-5">{{ failmessage }}</h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="!requestloading && !requestfail && !requestsuccess"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">credit_card</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />

              <label class="label is-medium">
                رجاء ادخال رقم البطاقة
                <br />
                ل{{ requeststring }}
              </label>

              <div class="field-body">
                <div class="field has-addons is-fullwidth">
                  <p class="control is-expanded">
                    <input
                      v-model="requestInfo.CardNumber"
                      name="CardNumber"
                      class="input has-text-centered is-large"
                      autofocus
                      placeholder="آخر تسع أرقام في البطاقة"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min: 9,
                        max: 9,
                      }"
                    />
                  </p>

                  <p class="control is-expanded">
                    <input
                      class="input has-text-centered is-large"
                      type="text"
                      autofocus
                      value="4587873
                                    "
                      disabled
                      placeholder="اول ثمانية ارقام في بطاقة"
                      v-validate="{ required: true, numaric: true }"
                    />
                  </p>
                </div>
              </div>
              <span
                v-show="errors.has('CardNumber')"
                class="help is-danger is-centered"
                >{{ errors.first("CardNumber") }}</span
              >
              <!-- <div class="control mb-10">
                  <span
                    v-show="errors.has('chargevalue')"
                    class="help is-danger is-centered"
                  >{{ errors.first('chargevalue') }}</span>

                  <hr>
                  الحد الأقصي ل{{requeststring }} هو
                  <span
                    class="tag is-warning is-bold has-text-black is-large has-text-bold"
                  >${{ maxvalue }}</span>
                  <br>

                  <p>
                    عدد افراد الاسرة :
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{ familyMembersCount }}</span> قيمة للفرد:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >${{amountPerPerson}}</span>
                    <br>رصيد الحساب الجاري بدينار:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{CustomerBalance}} د.ل</span>- سعر الصرف:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{exChangeRate}}</span>
                  </p>
              </div>-->
              <br />
              <div class="field mt-5">
                <label class="label is-medium">المخصصات عن الفترة</label>

                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="select is-fullwidth is-medium">
                        <select
                          class="select"
                          v-validate="'required'"
                          v-model="selectedversion"
                          name="version"
                          oninput="setCustomValidity('')"
                          placeholder="الصرفة"
                        >
                          <option
                            v-for="version in versions"
                            v-bind:key="version.id"
                            v-bind:value="version.id"
                          >
                            {{ version.name }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-show="errors.has('version')"
                        class="help is-danger is-centered"
                        >{{ errors.first("version") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="field mt-5">
                <label class="label is-medium">عدد الأفراد</label>

                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input has-text-centered is-large"
                        type="number"
                        min="1"
                        v-model="requestInfo.memberCount"
                        name="memberCount"
                        v-validate="{ required: true, numeric: true }"
                      />
                    </div>
                    <span
                      v-show="errors.has('memberCount')"
                      class="help is-danger is-centered"
                      >{{ errors.first("memberCount") }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="hero-foot has-text-centered mt-20 mb-20">
              <a
                class="button btn secondary-btn raised btn-align modal-dismiss is-bold is-medium"
                v-on:click="validateBeforeSubmit()"
              >
                <b>تأكيد رقم البطاقة والاستمرار</b>
              </a>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>

      <div
        class="columns is-vcentered"
        v-else-if="requestsuccess && !requestloading && !requestfail"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">
                تم ارسال طلب {{ requeststring }} بنجاح
              </h1>

              <h1 class="subtitle is-5">
                سيتم تنبيهك عند الانتهاء من معالجة طلبك
              </h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  props: ["requeststring", "requestid"],

  data() {
    return {
      requestloading: false,
      requestsuccess: false,
      requestfail: false,
      CustomerBalance: "",
      exChangeRate: "",
      familyMembersCount: "",
      amountPerPerson: "",
      chargevalue: null,
      failmessage: "",
      ischargeconfirmed: true,
      userid: null,
      requestInfo: {
        Customer_Id: null,
        CardNumber: "",
        Notes: "new request",
        memberCount: 1,
      },
      preinfo: {
        status: true,
      },
      versions: {},
      selectedversion: null,
    };
  },
  computed: {
    maxvalue() {
      // if (
      //   this.familyMembersCount * this.amountPerPerson >=
      //   this.CustomerBalance / this.exChangeRate
      // ) {
      //   return parseFloat(
      //     Math.round((this.CustomerBalance / this.exChangeRate) * 100) / 100
      //   ).toFixed(2);
      // } else {
      //   return parseFloat(
      //     Math.round(this.familyMembersCount * this.amountPerPerson * 100) / 100
      //   ).toFixed(2);
      // }
    },
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendrequest();
          return;
        }
      });
    },
    sendrequest() {
      // this.requestloading=true;
      this.requestloading = true;
      this.requestInfo.amountPerFamilyMemberValuesId = this.selectedversion;

      axios
        .post("familyfcp/newRequest_v3", this.requestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          // console.log(response.data);

          // console.log(response.data.status);

          if (response.data.status == "success") {
            this.requestsuccess = true;
            this.requestloading = false;
            this.requestfail = false;
          } else if (response.data.status == "fail") {
            this.requestfail = true;
            this.requestsuccess = false;

            this.failmessage = response.data.message;
            this.ischargeconfirmed = false;
            this.requestloading = false;
          }
        })
        .catch((error) => {});
    },
  },
  mounted() {
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        CardNumber: "رقم البطاقة",
        version: "المخصصات عن الفترة",
        memberCount: "عدد الأفراد",
      },
      custom: {
        CardNumber: {
          max: "رقم البطاقة يجب ان تحتوي على 9 ارقام على الأكثر.",
          min: "رقم البطاقة يجب ان تحتوي على 9 ارقام على الأقل.",
        },
      },
    });

    var user = JSON.parse(localStorage.getItem("user"));

    this.requestInfo.Customer_Id = user[1];

    axios
      .post("/FCBValues/", this.preinfo)
      .then((response) => {
        this.$root.kick(response.data.message);
        this.versions = response.data.data;
      })
      .catch((error) => {});
  },
};
</script>
